import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import ImageViewer from 'containers/Product/ImageViewer';
import styles from './styles';

const GallerySlice = ({ block }) => {
  if (!block) return '';
  const { primary } = block;

  const imageOne = primary?.image_one ? primary.image_one.url : null;
  const imageTwo = primary.image_two ? primary.image_two.url : null;
  const imageThree = primary.image_three ? primary.image_three.url : null;
  const imageFour = primary.image_four ? primary.image_four.url : null;
  const imageViewOne = primary.image_view_one
    ? primary.image_view_one.url
    : null;
  const imageViewTwo = primary.image_view_two
    ? primary.image_view_two.url
    : null;
  const imageViewThree = primary.image_view_three
    ? primary.image_view_three.url
    : null;
  const imageViewFour = primary.image_view_four
    ? primary.image_view_four.url
    : null;

  const [activeView, setActiveView] = useState(null);
  const [imageIndex, setImageIndex] = useState(null);

  const galleryImages = [imageOne, imageTwo, imageThree, imageFour];
  const imagePlaceholder =
    'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/image-placeholder.png?v=1713953599';
  const imageViewer = [
    { node: { originalSrc: imageViewOne } },
    { node: { originalSrc: imageViewTwo } },
    { node: { originalSrc: imageViewThree } },
    { node: { originalSrc: imageViewFour } },
  ];
  const handleClose = () => {
    setActiveView(false);
  };

  // Warning: Causes auto scroll on page load
  // useEffect(() => {
  //   if (activeView) {
  //     console.log('active view reset', imageIndex);
  //     document.getElementById('anchorId').scrollIntoView();
  //   } else if (imageIndex !== null) {
  //     console.log('not active set', imageIndex);
  //     const topOfElement = document.querySelector('#anchorId').offsetTop - 200;
  //     window.scroll({ top: topOfElement, behavior: 'smooth' });
  //   }
  // }, [imageIndex]);

  const useKeypress = (key, action) => {
    useEffect(() => {
      function onKeyup(e) {
        if (e.key === key) action();
      }
      window.addEventListener('keyup', onKeyup);
      return () => window.removeEventListener('keyup', onKeyup);
    }, []);
  };

  useKeypress('Escape', () => {
    setActiveView(false);
  });

  return (
    <div className="gallery_tab_slice" id="anchorId">
      <div
        className={` ${
          activeView === true && imageIndex >= 0 && imageIndex < 4
            ? 'tab_active'
            : 'gallery_tab'
        }`}
      >
        {galleryImages.map((item, index) => {
          const handleViewImage = () => {
            setActiveView(true);
            setImageIndex(index);
          };
          return (
            <div
              className="column_block"
              onClick={item ? handleViewImage : null}
              key={index}
            >
              <div>
                <Image
                  draggable={false}
                  src={item ? item : imagePlaceholder}
                  alt={item?.alt ? item?.alt : 'view image'}
                  width={304}
                  height={304}
                />
              </div>

              {item ? (
                <div className="icon">
                  <Image
                    draggable={false}
                    src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-magnifyingglass-light.png?v=1713862866"
                    alt={item?.alt ? item?.alt : 'view image'}
                    width={24}
                    height={24}
                  />
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
      {activeView && (
        <ImageViewer
          imagesGallery={imageViewer}
          handleModalClose={handleClose}
          imageIndex={imageIndex}
          handleImageIndex={setImageIndex}
        />
      )}
      <style jsx>{styles}</style>
    </div>
  );
};

export default GallerySlice;
